import { setColumnsToUserPropertyTask, updateColumnsFromUserPropertyTask } from '../../../modules/EntitiesGrid';
import { columnsState } from './atoms';

const USER_SETTINGS_ATTR = 'incidentSettings' as const;

export const setColumnsTask = setColumnsToUserPropertyTask(USER_SETTINGS_ATTR, columnsState);

export const updateColumnsFromUserTask = updateColumnsFromUserPropertyTask(USER_SETTINGS_ATTR, columnsState);
